// import PenguinIntro from "./PenguinIntro";

import MissionIntro from './MissionIntro';
import Puzzle1 from './Puzzle1';
import BuildingOutro from './BuildingOutro';
import Puzzle2 from './Puzzle2';
import Puzzle3 from './Puzzle3';

export default [MissionIntro, Puzzle1, Puzzle2, Puzzle3, BuildingOutro];
